import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import Select from '../../../common/form/elements/select';
import DetailField from '../user/detail-field';

const model = 'deep.admin_ppc.management.manual_load.pot';
const selectValues = [
  { label: 'Personal', value: 'personal' },
  { label: 'NGP', value: 'personal_ngp' },
  { label: 'Price It Plus', value: 'personal_postcode_plan' }
];

class PpcLoadDetailsSelect extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(actions.change(model, 'personal'));
  }

  selectBalance = () => {
    const { pot } = this.props;

    switch (pot) {
      case 'personal':
        return 'available-points-balance';
      case 'personal_ngp':
        return 'available-ngp-points-balance';
      case 'personal_postcode_plan':
        return 'available-postcode-plan-points-balance';
      default:
        return 'available-points-balance';
    }
  }

  render() {
    const { pot, load } = this.props;

    return (
      <div>
        <div className="mg-bottom-20">
          Pot
          <Select
            model={model}
            value={pot}
            values={selectValues}
            hasEmptyValue={false}
          />
        </div>
        <div className="mg-bottom-20">
          <DetailField label="Available points balance">
            {load.attributes[this.selectBalance()]}
          </DetailField>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pot: state.deep.forms.admin_ppc.management.manual_load.pot.value
});

export default connect(mapStateToProps)(PpcLoadDetailsSelect);
